type Language = 'ko' | 'en' | 'ja';
import {
  formatPaymentMethodLabel,
  GetMaximumBenefit_payment_event_list_for_display_item_list as PaymentEventList,
} from '@domains/pdp-common';

import { findMaxDiscountAmount } from '../../utils/findMaxDiscountAmount';
import { PaymentBenefitCard } from './PaymentBenefitCard';

interface CombinePaymentEventList extends PaymentEventList {
  maxDiscountAmount: number;
}

interface BenefitCardListProps {
  language: Language;
  list: PaymentEventList[];
  onClick: (item: PaymentEventList) => void;
}

export const PaymentBenefitCardList: React.FC<React.PropsWithChildren<BenefitCardListProps>> = ({ language, list, onClick }) => {
  const filteredList = list.reduce((acc, cur) => {
    const { payment_event_detail_list } = cur;
    if (payment_event_detail_list.length === 0) {
      return acc;
    }
    const maxDiscountAmount = findMaxDiscountAmount(payment_event_detail_list);
    if (maxDiscountAmount === 0) {
      return acc;
    }
    acc.push({
      ...cur,
      maxDiscountAmount,
    });
    return acc;
  }, [] as CombinePaymentEventList[]);

  return (
    <>
      {filteredList.map((item, idx) => {
        const { financial_company_code, maxDiscountAmount, payment_method, payment_method_type } = item;
        const companyCode = financial_company_code as string;
        const cardName = formatPaymentMethodLabel(language, companyCode, payment_method, payment_method_type);

        return (
          <PaymentBenefitCard
            key={`${cardName}_${maxDiscountAmount}_${idx}`}
            cardName={cardName}
            discount_amount={maxDiscountAmount}
            onClick={() => onClick(item)}
          />
        );
      })}
    </>
  );
};
